import { useSelector } from 'react-redux';
import { getCloudflareHardBlocked } from 'domains/Auth/authSlice/authSelectors';
import dashboardService from '../../services';

function useCloudflareBlocked() {
  const cloudflareHardBlocked = useSelector(getCloudflareHardBlocked);

  const validateIPs = async () => {
    const { migrationSuccess } =
      await dashboardService.cloudflareIPsMigrationCheck();

    return migrationSuccess;
  };

  return {
    cloudflareHardBlocked,
    validateIPs,
  };
}

export default useCloudflareBlocked;
